// extracted by mini-css-extract-plugin
export default {"root":"LoadingPanel_root__Vwaf-","loadingContainer":"LoadingPanel_loadingContainer__zqxSW","loading":"LoadingPanel_loading__On4B-","loadingTitle":"LoadingPanel_loadingTitle__MSjvI"};